// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_1B1ZT","Head":"Hero__Head_3B8L3","Title":"Hero__Title_2mpNg"};